import { useMemo } from 'react';

// 更换为一组风格鲜明的 SVG 图标
const icons = {
  booth: (
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
    </svg>
  ), // 平台管理：多窗口/面板
  event: (
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M8 3v4M16 3v4" />
      <path d="M7 10h10" />
      <path d="M7 14h6" />
    </svg>
  ), // 赛事管理：日历+横线
  referee: (
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="8" r="4" />
      <path d="M6 20v-2a6 6 0 0 1 12 0v2" />
      <path d="M12 12v4" />
    </svg>
  ), // 裁判管理：用户+底座
  org: (
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M2 9l10-6 10 6" />
      <rect x="4" y="10" width="16" height="10" rx="2" />
      <path d="M9 21V12h6v9" />
    </svg>
  ), // 学校/机构管理：屋顶+楼体
  sub: (
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="8" r="4" />
      <path d="M16 16v-1a4 4 0 0 0-8 0v1" />
      <path d="M19 16v6" />
      <path d="M22 19h-6" />
    </svg>
  ), // 子账号：用户+加号
};
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function SideNav() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const { user } = useSelector((state) => state.auth);

  const navLinks = useMemo(() => {
    const links = [
      {
        path: '/booth',
        label: '我的平台',
        icon: icons.booth,
      },
      {
        path: '/',
        label: '我的赛事',
        icon: icons.event,
      },
      {
        path: '/referee',
        label: '我合作的裁判',
        icon: icons.referee,
      },
      {
        path: '/organization',
        label: '我合作的参赛单位',
        icon: icons.org,
      },
    ];
    if (user?.org?.mainAccount) {
      links.push({
        path: '/sub-account',
        label: '子账号',
        icon: icons.sub,
      });
    }
    return links;
  }, [user]);

  return (
    <aside className="w-56">
      <nav className="flex flex-col gap-2 fixed z-10 bg-slate-50 rounded-lg">
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`flex items-center px-4 py-3 rounded-lg font-medium text-base transition-colors duration-150 cursor-pointer gap-2 w-50 ${
              isActive(link.path)
                ? 'bg-blue-100 text-blue-600'
                : 'text-slate-600 hover:bg-slate-100 hover:text-blue-600'
            }`}
          >
            {link.icon}
            {link.label}
          </Link>
        ))}
      </nav>
    </aside>
  );
}
